import { render, staticRenderFns } from "./ResidSubmit.vue?vue&type=template&id=5121a246&scoped=true&"
import script from "./ResidSubmit.vue?vue&type=script&lang=js&"
export * from "./ResidSubmit.vue?vue&type=script&lang=js&"
import style0 from "./ResidSubmit.vue?vue&type=style&index=0&id=5121a246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5121a246",
  null
  
)

export default component.exports